export type QuoteIdentity = {
  chainId: number;
  marketAddress: string;
  optionAddress: string;
  side: 'buy' | 'sell';
  amount: bigint;
};

export type TradeQuote = {
  data?: bigint;
  isError: boolean;
  isFetching: boolean;
};

export const quoteKey = (quote: QuoteIdentity): string =>
  [
    quote.chainId,
    quote.marketAddress.toLowerCase(),
    quote.optionAddress.toLowerCase(),
    quote.side,
    quote.amount.toString(),
  ].join(':');

export const isQuoteUsable = (
  quote: TradeQuote,
  quotedInput?: QuoteIdentity,
  currentInput?: QuoteIdentity
): quote is TradeQuote & { data: bigint } =>
  !quote.isError &&
  !quote.isFetching &&
  quote.data !== undefined &&
  quote.data > 0n &&
  quotedInput !== undefined &&
  currentInput !== undefined &&
  quoteKey(quotedInput) === quoteKey(currentInput);

export const minimumOutput = (expectedOutput: bigint, slippageBps: number): bigint => {
  if (expectedOutput <= 0n || !Number.isInteger(slippageBps) || slippageBps < 0 || slippageBps >= 10000) {
    throw new Error('invalid-quote');
  }

  const minimum = (expectedOutput * BigInt(10000 - slippageBps)) / 10000n;
  if (minimum <= 0n) throw new Error('output-too-small');
  return minimum;
};

export const transactionDeadline = (nowMs: number, minutes: number): bigint => {
  if (!Number.isFinite(nowMs) || !Number.isFinite(minutes) || minutes <= 0 || minutes > 1440) {
    throw new Error('invalid-deadline');
  }

  return BigInt(Math.floor(nowMs / 1000) + Math.ceil(minutes * 60));
};
